@if (startContent) {
<div class="icon-container">
  <app-icon class="icon-icon" icon="case_opening" />
</div>
<div class="message">
  <span class="message-title">Supply Drop started</span>
  <div class="message-content">
    <img class="case-image" [src]="startContent.caseImage" alt="" />
    <span>{{ startContent.caseName }}</span>
  </div>
</div>
} @if (endContent) {
<div class="icon-container">
  <img class="avatar" [src]="endContent.winnerAvatar" alt="" />
</div>
<div class="message">
  <span class="message-title">{{ endContent.winnerName }} won the Supply Drop</span>
  <div class="message-content">
    <img class="case-image" [src]="endContent.caseImage" alt="" />
    <app-currency [value]="endContent.dropValue" [size]="12"></app-currency>
    <span>|</span>
    <span>{{ endContent.playerCount }} players, {{ endContent.winChance }}% chance</span>
  </div>
</div>
}
